'use client';

import { useEffect, useRef } from 'react';

import { postToHost } from '../lib/hostSignal';

/** Tells the host that this widget failed to load. Renders nothing. */
export function HostErrorSignal({ eventTicker }: { eventTicker?: string }) {
    const sentRef = useRef(false);
    useEffect(() => {
        if (sentRef.current) return;
        sentRef.current = true;
        postToHost({ type: 'kalshi-widget-error', reason: 'unavailable', ...(eventTicker ? { eventTicker } : {}) });
    }, [eventTicker]);
    return null;
}
